import { useEffect, useState } from "react";
import { getUserInfo } from "../../apis/General/users";
import "../../styles/ThirdParty/Search.scss";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Notifications from "../shared/Notifications";
import Logo from "../../images/closecarbon_logo_1-removebg-preview 1.png";


const pages = [
  {
    name: "monitoring",
    alias: "home carbon",
  },
  {
    name: "validation",
    alias: "validate carbon",
  },
  {
    name: "verification",
    alias: "verify carbon",
  },
  {
    name: "CCRT",
  },
  {
    name: "profile",
  },
  {
    name: "iot devices",
  },
];

const Search = () => {
  const auth = useSelector((state) => state.auth);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [firstName, setFirstName] = useState("");
  const [word, setWord] = useState("");

  const [lastName, setLastName] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [searchModalOpen, setSearchModalOpen] = useState(false);
  const handleModalOpen = () => setModalOpen(true);
  const handleModalClose = () => setModalOpen(false);
  const [kycStatus, setKycStatus] = useState("");
  const [listOfNames, setListOfNames] = useState(
    pages.map((item) => item?.name)
  );
  const fetchUserInfo = async () => {
    const response = await getUserInfo(auth?.userInfo?.id, auth?.token);
    setFirstName(response?.data?.message?.firstName);
    setLastName(response?.data?.message?.lastName);
  };

  useEffect(() => {
    fetchUserInfo();
  }, []);

  useEffect(() => {
    if (word.trim() === "") {
      setListOfNames(pages.map((item) => item?.name));
    } else {
      const temp = pages.filter(
        (page) => page?.name?.includes(word) || page?.alias?.includes(word)
      );
      setListOfNames(temp.map((item) => item?.name));
    }
  }, [word]);

  const handeMobileMenuOpen = () => {
    console.log("hello");
    dispatch({
      type: "SET_MENU_VISIBLE",
      payload: true,
    });
  };

  const handleSearchModalOpen = () => setSearchModalOpen(true);
  const handleSearchModalClose = (e) => {
    if (e.target.classList.contains("search-list-modal")) {
      setSearchModalOpen(false);
    }
  }

  return (
    <div className="thirdparty_search_container">
      <div>
        <div className="mobile_menu">
          <svg
            onClick={handeMobileMenuOpen}
            width="18"
            height="10"
            viewBox="0 0 18 10"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1 1H17"
              stroke="#667185"
              stroke-width="2"
              stroke-linecap="round"
            />
            <path
              d="M1 5H17"
              stroke="#667185"
              stroke-width="2"
              stroke-linecap="round"
            />
            <path
              d="M1 9H17"
              stroke="#667185"
              stroke-width="2"
              stroke-linecap="round"
            />
          </svg>

          <img
            src={Logo}
            alt=""
            className="logo pointer"
            onClick={() => navigate("/dashboard")}
          />
        </div>
        <form className="search_form">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10.77 18.3C9.2807 18.3 7.82485 17.8584 6.58655 17.031C5.34825 16.2036 4.38311 15.0275 3.81318 13.6516C3.24325 12.2757 3.09413 10.7616 3.38468 9.30096C3.67523 7.84029 4.39239 6.49857 5.44548 5.44548C6.49857 4.39239 7.84029 3.67523 9.30096 3.38468C10.7616 3.09413 12.2757 3.24325 13.6516 3.81318C15.0275 4.38311 16.2036 5.34825 17.031 6.58655C17.8584 7.82485 18.3 9.2807 18.3 10.77C18.3 11.7588 18.1052 12.738 17.7268 13.6516C17.3484 14.5652 16.7937 15.3953 16.0945 16.0945C15.3953 16.7937 14.5652 17.3484 13.6516 17.7268C12.738 18.1052 11.7588 18.3 10.77 18.3ZM10.77 4.74999C9.58331 4.74999 8.42327 5.10189 7.43657 5.76118C6.44988 6.42046 5.68084 7.35754 5.22672 8.45389C4.77259 9.55025 4.65377 10.7566 4.88528 11.9205C5.11679 13.0844 5.68824 14.1535 6.52735 14.9926C7.36647 15.8317 8.43556 16.4032 9.59945 16.6347C10.7633 16.8662 11.9697 16.7474 13.0661 16.2933C14.1624 15.8391 15.0995 15.0701 15.7588 14.0834C16.4181 13.0967 16.77 11.9367 16.77 10.75C16.77 9.15869 16.1379 7.63257 15.0126 6.50735C13.8874 5.38213 12.3613 4.74999 10.77 4.74999Z"
              fill="#667185"
            />
            <path
              d="M20 20.75C19.9014 20.7504 19.8038 20.7312 19.7128 20.6934C19.6218 20.6557 19.5392 20.6001 19.47 20.53L15.34 16.4C15.2075 16.2578 15.1354 16.0697 15.1388 15.8754C15.1422 15.6811 15.2209 15.4958 15.3583 15.3583C15.4958 15.2209 15.6811 15.1422 15.8754 15.1388C16.0697 15.1354 16.2578 15.2075 16.4 15.34L20.53 19.47C20.6704 19.6106 20.7493 19.8012 20.7493 20C20.7493 20.1987 20.6704 20.3893 20.53 20.53C20.4607 20.6001 20.3782 20.6557 20.2872 20.6934C20.1961 20.7312 20.0985 20.7504 20 20.75Z"
              fill="#667185"
            />
          </svg>

          <input
            className="search_input"
            type="text"
            placeholder="Search"
            name={word}
            onClick={() => {
              if(!searchModalOpen) {
                handleSearchModalOpen();
              }
            }}
            onChange={(e) => setWord(e.target.value)}
          />
          {searchModalOpen && 
         
            <div className="search-list">
            {listOfNames.includes("monitoring") && (
              <div className="search-list__flex"
              onClick={() => {
                navigate("/third-party/dashboard");
                window.scrollTo(0, 0);
              }}
              >
               <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M21 12.5V17H3V5H8.25V3.5H3C2.60218 3.5 2.22064 3.65804 1.93934 3.93934C1.65804 4.22064 1.5 4.60218 1.5 5V17C1.5 17.3978 1.65804 17.7794 1.93934 18.0607C2.22064 18.342 2.60218 18.5 3 18.5H9V21.5H6V23H18V21.5H15V18.5H21C21.3978 18.5 21.7794 18.342 22.0607 18.0607C22.342 17.7794 22.5 17.3978 22.5 17V12.5H21ZM13.5 21.5H10.5V18.5H13.5V21.5Z"
              fill="#667185"
            />
            <path
              d="M13.5 14.0001H13.4925C13.3309 13.9984 13.1742 13.9445 13.0456 13.8466C12.9171 13.7486 12.8237 13.6117 12.7792 13.4563L11.4345 8.75008H8.25V7.25008H12C12.163 7.24999 12.3216 7.30302 12.4518 7.40113C12.582 7.49924 12.6767 7.6371 12.7215 7.79383L13.527 10.6138L15.7838 3.27883C15.8324 3.12662 15.9278 2.99361 16.0564 2.8987C16.185 2.80378 16.3402 2.75178 16.5 2.75008C16.658 2.74771 16.8126 2.79633 16.9408 2.88874C17.069 2.98115 17.164 3.11242 17.2118 3.26308L18.54 7.25008H22.5V8.75008H18C17.8425 8.75012 17.689 8.70059 17.5613 8.60851C17.4335 8.51644 17.338 8.38649 17.2882 8.23708L16.5285 5.95708L14.217 13.4706C14.1698 13.6239 14.0747 13.7581 13.9457 13.8534C13.8166 13.9487 13.6604 14.0001 13.5 14.0001Z"
              fill="#667185"
            />
          </svg>

                <div>Monitoring</div>
              </div>
            )}
            {listOfNames.includes("validation") && (
              <div className="search-list__flex"
              onClick={() => {
                navigate("/third-party/validation");
                window.scrollTo(0, 0);
              }}
              >
                <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10.125 23.1113C9.9954 23.1112 9.86802 23.0777 9.75525 23.0138L3.38025 19.4025C3.26482 19.3371 3.16881 19.2423 3.102 19.1276C3.0352 19.013 3 18.8827 3 18.75V11.25C3 11.1174 3.0352 10.9871 3.102 10.8724C3.16881 10.7578 3.26482 10.6629 3.38025 10.5975L9.75525 6.98628C9.86803 6.92246 9.99541 6.88892 10.125 6.88892C10.2546 6.88892 10.382 6.92246 10.4948 6.98628L16.8698 10.5975C16.9852 10.6629 17.0812 10.7578 17.148 10.8724C17.2148 10.9871 17.25 11.1174 17.25 11.25V18.75C17.25 18.8827 17.2148 19.013 17.148 19.1276C17.0812 19.2423 16.9852 19.3371 16.8698 19.4025L10.4948 23.0138C10.382 23.0777 10.2546 23.1112 10.125 23.1113ZM4.5 18.3128L10.125 21.4988L15.75 18.3128V11.6873L10.125 8.50128L4.5 11.6865V18.3128Z"
              fill="#667185"
            />
            <path
              d="M21.0001 12.75H19.5001V5.68728L13.8751 2.50128L7.86987 5.90253L7.13037 4.59753L13.5054 0.986282C13.6182 0.922459 13.7455 0.888916 13.8751 0.888916C14.0047 0.888916 14.1321 0.922459 14.2449 0.986282L20.6199 4.59753C20.7353 4.66294 20.8313 4.7578 20.8981 4.87243C20.9649 4.98706 21.0001 5.11736 21.0001 5.25003V12.75Z"
              fill="#667185"
            />
          </svg>

                <div>Validation</div>
              </div>
            )}
            {listOfNames.includes("verification") && (
              <div className="search-list__flex"
              onClick={() => {
                navigate("/third-party/verification");
                window.scrollTo(0, 0);
              }}
              >
                <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M18 21H22.5V22.5H18V21Z" fill="#667185" />
            <path
              d="M15.75 22.5C16.1642 22.5 16.5 22.1642 16.5 21.75C16.5 21.3358 16.1642 21 15.75 21C15.3358 21 15 21.3358 15 21.75C15 22.1642 15.3358 22.5 15.75 22.5Z"
              fill="#667185"
            />
            <path
              d="M21.75 19.5C22.1642 19.5 22.5 19.1642 22.5 18.75C22.5 18.3358 22.1642 18 21.75 18C21.3358 18 21 18.3358 21 18.75C21 19.1642 21.3358 19.5 21.75 19.5Z"
              fill="#667185"
            />
            <path
              d="M19.5 19.5H15V18H19.5V19.5ZM18 15H22.5V16.5H18V15Z"
              fill="#667185"
            />
            <path
              d="M15.75 16.5C16.1642 16.5 16.5 16.1642 16.5 15.75C16.5 15.3358 16.1642 15 15.75 15C15.3358 15 15 15.3358 15 15.75C15 16.1642 15.3358 16.5 15.75 16.5Z"
              fill="#667185"
            />
            <path
              d="M16.1198 10.5974L9.74475 6.98615C9.63199 6.92226 9.5046 6.88867 9.375 6.88867C9.2454 6.88867 9.11801 6.92226 9.00525 6.98615L2.63025 10.5974C2.51482 10.6628 2.41881 10.7577 2.352 10.8723C2.2852 10.9869 2.25 11.1172 2.25 11.2499V18.7499C2.25 18.8826 2.2852 19.0129 2.352 19.1275C2.41881 19.2421 2.51482 19.337 2.63025 19.4024L9.00525 23.0136L9.74475 21.7087L3.75 18.3126V11.6872L9.375 8.50115L15 11.6872V13.4999H16.5V11.2499C16.5 11.1172 16.4648 10.9869 16.398 10.8723C16.3312 10.7577 16.2352 10.6628 16.1198 10.5974Z"
              fill="#667185"
            />
            <path
              d="M18.7501 11.2499H20.2501V5.2499C20.2501 5.11723 20.2149 4.98693 20.1481 4.8723C20.0813 4.75767 19.9853 4.66281 19.8699 4.5974L13.4949 0.98615C13.3821 0.922256 13.2547 0.888672 13.1251 0.888672C12.9955 0.888672 12.8681 0.922256 12.7554 0.98615L6.38037 4.5974L7.11987 5.9024L13.1251 2.5004L18.7501 5.68715V11.2499Z"
              fill="#667185"
            />
          </svg>

                <div>Verification</div>
              </div>
            )}
            {listOfNames.includes("CCRT") && (
              <div className="search-list__flex"
              onClick={() => {
                navigate("/third-party/carbon-credit-issuance");
                window.scrollTo(0, 0);
              }}
              >
               <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M22.1318 13.2668L17.6318 10.6043C17.5162 10.5358 17.3843 10.4997 17.2499 10.4999C17.1155 10.5 16.9837 10.5363 16.8682 10.605L12.3682 13.2675C12.2561 13.3337 12.1631 13.428 12.0985 13.5411C12.0339 13.6543 12 13.7823 12 13.9125V19.0875C12 19.353 12.1402 19.5983 12.3682 19.7325L16.8682 22.395C16.9836 22.4643 17.1155 22.5008 17.25 22.5008C17.3845 22.5008 17.5164 22.4643 17.6318 22.395L22.1318 19.7325C22.2439 19.6664 22.3369 19.5721 22.4015 19.4589C22.4661 19.3458 22.5 19.2178 22.5 19.0875V13.9125C22.5 13.7822 22.4661 13.6541 22.4015 13.5408C22.3369 13.4276 22.244 13.3331 22.1318 13.2668ZM21 18.66L17.25 20.8785L13.5 18.66V14.34L17.25 12.1215L21 14.34V18.66Z"
              fill="#667185"
            />
            <path
              d="M4.5 5.25C4.91421 5.25 5.25 4.91421 5.25 4.5C5.25 4.08579 4.91421 3.75 4.5 3.75C4.08579 3.75 3.75 4.08579 3.75 4.5C3.75 4.91421 4.08579 5.25 4.5 5.25Z"
              fill="#667185"
            />
            <path
              d="M6.75 5.25C7.16421 5.25 7.5 4.91421 7.5 4.5C7.5 4.08579 7.16421 3.75 6.75 3.75C6.33579 3.75 6 4.08579 6 4.5C6 4.91421 6.33579 5.25 6.75 5.25Z"
              fill="#667185"
            />
            <path
              d="M21 1.5H3C2.17275 1.5 1.5 2.17275 1.5 3V18C1.5 18.8272 2.17275 19.5 3 19.5H9.75V18H3V7.5H21V10.5H22.5V3C22.5 2.17275 21.8272 1.5 21 1.5ZM3 6V3H21V6H3Z"
              fill="#667185"
            />
          </svg>

                <div>CCRT</div>
              </div>
            )}

            {listOfNames.includes("iot devices") && (
              <div className="search-list__flex"
              onClick={() => {
                navigate("/third-party/iot");
                window.scrollTo(0, 0);
              }}
              >
                <svg
            className="stroke"
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M14 1H15C15.5304 1 16.0391 1.21071 16.4142 1.58579C16.7893 1.96086 17 2.46957 17 3V4M17 14V15C17 15.5304 16.7893 16.0391 16.4142 16.4142C16.0391 16.7893 15.5304 17 15 17H14M4 17H3C2.46957 17 1.96086 16.7893 1.58579 16.4142C1.21071 16.0391 1 15.5304 1 15V14M1 4V3C1 2.46957 1.21071 1.96086 1.58579 1.58579C1.96086 1.21071 2.46957 1 3 1H4M9 15V17M1 9H3M9 1V3M17 9H15M6 9C6 9.79565 6.31607 10.5587 6.87868 11.1213C7.44129 11.6839 8.20435 12 9 12C9.79565 12 10.5587 11.6839 11.1213 11.1213C11.6839 10.5587 12 9.79565 12 9C12 8.20435 11.6839 7.44129 11.1213 6.87868C10.5587 6.31607 9.79565 6 9 6C8.20435 6 7.44129 6.31607 6.87868 6.87868C6.31607 7.44129 6 8.20435 6 9Z"
              stroke="#667185"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>

                <div>IoT Devices</div>
              </div>
            )}
            {listOfNames.includes("profile") && (
              <div className="search-list__flex"
              onClick={() => {
                navigate("/third-party/profile");
                window.scrollTo(0, 0);
              }}
              >
                <svg
            className="stroke"
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M14 1H15C15.5304 1 16.0391 1.21071 16.4142 1.58579C16.7893 1.96086 17 2.46957 17 3V4M17 14V15C17 15.5304 16.7893 16.0391 16.4142 16.4142C16.0391 16.7893 15.5304 17 15 17H14M4 17H3C2.46957 17 1.96086 16.7893 1.58579 16.4142C1.21071 16.0391 1 15.5304 1 15V14M1 4V3C1 2.46957 1.21071 1.96086 1.58579 1.58579C1.96086 1.21071 2.46957 1 3 1H4M9 15V17M1 9H3M9 1V3M17 9H15M6 9C6 9.79565 6.31607 10.5587 6.87868 11.1213C7.44129 11.6839 8.20435 12 9 12C9.79565 12 10.5587 11.6839 11.1213 11.1213C11.6839 10.5587 12 9.79565 12 9C12 8.20435 11.6839 7.44129 11.1213 6.87868C10.5587 6.31607 9.79565 6 9 6C8.20435 6 7.44129 6.31607 6.87868 6.87868C6.31607 7.44129 6 8.20435 6 9Z"
              stroke="#667185"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>

                <div>Profile</div>
              </div>
            )}
            
          </div>
          }
        </form>
      </div>
      <div className="search_flex">
        {/* <div className="notification pointer" onClick={handleModalOpen}>
          <svg
            className="badge"
            width="7"
            height="6"
            viewBox="0 0 7 6"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M3.5 6C5.15685 6 6.5 4.65685 6.5 3C6.5 1.34315 5.15685 0 3.5 0C1.84315 0 0.5 1.34315 0.5 3C0.5 4.65685 1.84315 6 3.5 6Z"
              fill="#D42620"
            />
          </svg>

          <svg
            width="20"
            height="23"
            viewBox="0 0 20 23"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M17.5 12.4395V10.5H16V12.75C16 12.9489 16.0791 13.1396 16.2197 13.2803L18.25 15.3105V16.5H1.75V15.3105L3.78025 13.2803C3.92091 13.1396 3.99996 12.9489 4 12.75V9.75C3.99791 8.6961 4.27398 7.6603 4.80032 6.74724C5.32665 5.83417 6.08463 5.07618 6.99767 4.5498C7.91072 4.02343 8.9465 3.74733 10.0004 3.74938C11.0543 3.75144 12.089 4.03157 13 4.5615V2.88525C12.2861 2.56914 11.5267 2.36766 10.75 2.28825V0.75H9.25V2.2875C7.40093 2.4757 5.68732 3.34284 4.44053 4.72124C3.19373 6.09964 2.50233 7.89138 2.5 9.75V12.4395L0.46975 14.4697C0.329088 14.6104 0.250042 14.8011 0.25 15V17.25C0.25 17.4489 0.329018 17.6397 0.46967 17.7803C0.610322 17.921 0.801088 18 1 18H6.25V18.75C6.25 19.7446 6.64509 20.6984 7.34835 21.4016C8.05161 22.1049 9.00544 22.5 10 22.5C10.9946 22.5 11.9484 22.1049 12.6517 21.4016C13.3549 20.6984 13.75 19.7446 13.75 18.75V18H19C19.1989 18 19.3897 17.921 19.5303 17.7803C19.671 17.6397 19.75 17.4489 19.75 17.25V15C19.75 14.8011 19.6709 14.6104 19.5303 14.4697L17.5 12.4395ZM12.25 18.75C12.25 19.3467 12.0129 19.919 11.591 20.341C11.169 20.7629 10.5967 21 10 21C9.40326 21 8.83097 20.7629 8.40901 20.341C7.98705 19.919 7.75 19.3467 7.75 18.75V18H12.25V18.75Z"
              fill="#667185"
            />
          </svg>
        </div> */}
        <div
          className="profile"
          onClick={() => {
            navigate("/third-party/profile");
            window.scrollTo(0, 0);
          }}
        >
          <div className="search_name">
            {firstName?.split("")[0]}
            {lastName?.split("")[0]}
            <svg
              className="kyc_svg"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M13.0758 2.14075C13.31 2.14075 13.5 1.935 13.5 1.68225V0.95825C13.5 0.705 13.31 0.5 13.0758 0.5H2.92425C2.68975 0.5 2.5 0.705 2.5 0.95825V1.68225C2.5 1.935 2.68975 2.1405 2.92425 2.1405H3.1875V13.8593H2.92425C2.68975 13.8593 2.5 14.0642 2.5 14.3175V15.0413C2.5 15.2945 2.68975 15.5 2.92425 15.5H13.0755C13.31 15.5 13.5 15.2945 13.5 15.0413V14.3175C13.5 14.0642 13.31 13.8593 13.0758 13.8593H12.8125V2.14075H13.0758ZM3.64575 13.8595V2.14075H4.07675C3.9655 2.14075 3.875 2.2245 3.875 2.328V2.8905C3.875 2.994 3.9645 3.07725 4.0755 3.078C4.0755 5.15025 4.4075 7.16425 6.8085 7.85825L6.927 7.89575C7.03075 7.92875 7.155 7.96775 7.2185 8C7.155 8.03175 7.03225 8.07075 6.929 8.10325L6.81575 8.1395C4.40775 8.836 4.07575 10.8498 4.07575 12.922C3.965 12.9227 3.87525 13.0063 3.87525 13.1093V13.6718C3.87525 13.7753 3.9655 13.8595 4.077 13.8595H3.64575ZM8.9365 8.55125L9.06 8.59025C10.7615 9.08225 11.4257 10.2015 11.4642 12.6875H8.204C8.17125 11.5315 8.08925 8.57925 8.08925 8C8.08925 7.80375 8.45225 7.5285 8.61925 7.43025C9.324 7.014 10.2305 6.1905 10.2305 5.3335H5.769C5.769 6.1905 6.6755 7.014 7.38025 7.43025C7.54675 7.52875 7.91025 7.80375 7.91025 8C7.91025 8.5945 7.8285 11.5345 7.79575 12.6875H4.53575C4.574 10.2022 5.239 9.0825 6.947 8.58825L7.06425 8.5515C7.3925 8.448 7.7025 8.35 7.7025 8.00025C7.7025 7.65 7.3915 7.55175 7.06175 7.44825L6.93975 7.4095C5.2385 6.9175 4.57425 5.7985 4.536 3.31275H11.4648C11.4263 5.7985 10.7615 6.91825 9.054 7.41175L8.93975 7.448C8.60975 7.5515 8.298 7.64975 8.298 8.00025C8.2975 8.34975 8.608 8.44775 8.9365 8.55125ZM12.354 13.8595H11.9235C12.0345 13.8595 12.125 13.7753 12.125 13.6718V13.1093C12.125 13.006 12.035 12.9227 11.9242 12.9222C11.9242 10.8497 11.5922 8.8355 9.19125 8.1415L9.07125 8.1035C8.96825 8.071 8.845 8.032 8.7815 8.00025C8.84525 7.968 8.96975 7.929 9.07375 7.896L9.1845 7.86075C11.5922 7.16475 11.9242 5.15075 11.9242 3.07825C12.0347 3.07775 12.125 2.99425 12.125 2.8905V2.328C12.125 2.2245 12.0347 2.14075 11.9235 2.14075H12.354V13.8595Z"
                fill={
                  kycStatus === "pending"
                    ? "#00AED9"
                    : kycStatus === "completed"
                    ? "#0F973D"
                    : ""
                }
              />
            </svg>
            {kycStatus === "pending" ? (
              <div className="tag tag_progress">
                KYC confirmation <br /> in progress
              </div>
            ) : kycStatus === "completed" ? (
              <div className="tag">
                KYC confirmation <br /> completed
              </div>
            ) : (
              ""
            )}
          </div>

          <div className="profile_title">Profile</div>
        </div>
      </div>

      {modalOpen && <Notifications handleModalClose={handleModalClose} />}
      {searchModalOpen &&  <div className="search-list-modal" onClick={handleSearchModalClose}></div>}

    </div>
  );
};

export default Search;
